export default __webpack_public_path__ + "static/media/about_mobile.95183c9e.png";